export const getStandingOrderPostError = state => state.standingOrderReducer.postError;
export const getStandingOrderPostSuccess = state => state.standingOrderReducer.postSuccess;
export const getStandingOrderIsPosting = state => state.standingOrderReducer.isPosting;
export const getStandingOrderError = state => state.standingOrderReducer.error;
export const getStandingOrders = state => state.standingOrderReducer.standingOrders;
export const getStandingOrderIsFetching = state => state.standingOrderReducer.isFetching;
export const getSingleStandingOrder = (state, id) => state.standingOrderReducer.standingOrders[id];
